---
title: Function Overloading in Swift
date: 2019-03-03T18:32:28-07:00
draft: true
---

Php was a great time because the front and backend were one and the same. Simple. No templating or build steps. 

Nothing will ever merge the two again

Modern frontends are whole applications now. They will need their own data store and services

Modern backends do more than just sql queries. They need to do more than just pipe validated data to the user
